module.exports = __webpack_public_path__ + "674211ea0c24c09211c5185e951c8b4a.png";